import { cn } from '@heidi/utils';
import { useEffect, useState } from 'react';
import { HeidiLoader } from '../heidi-loader';

type FullPageLoaderProps = {
  /**
   * Hold the viewport empty (but sized) for this long before painting the
   * loader, so a redirect that resolves faster than the delay never flashes a
   * spinner. `0` paints immediately — correct for a hold the user is already
   * waiting on (a provider gate), wrong for a hand-off that usually resolves in
   * a frame or two (`/scribe`'s route decision).
   */
  delayMs?: number;
  className?: string;
};

/**
 * Full-viewport centred HeidiLoader. The boot-path loader shown before the nav
 * chrome exists — deliberately the SAME component/animation the content column
 * shows once the nav is up, so the two stages read as one loader repositioning.
 */
export const FullPageLoader = ({ delayMs = 0, className }: FullPageLoaderProps) => {
  const [show, setShow] = useState(delayMs === 0);

  useEffect(() => {
    const timer = setTimeout(() => setShow(true), delayMs);
    return () => clearTimeout(timer);
  }, [delayMs]);

  return (
    <div
      className={cn('flex h-dvh w-full items-center justify-center', className)}
      data-testid={show ? 'full-page-loader' : 'full-page-loader-pending'}
    >
      {show && <HeidiLoader />}
    </div>
  );
};
